<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>DATA FLOW</div>
				<h2 waHeading="l" waText>Request, Event, and Message Paths</h2>
				<p waBody="m" waColorText="quiet" waText>HTTP for pages, AJAX for events, WebSocket for real-time.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="mermaid-diagram-wrapper">
					<div class="mermaid-diagram-label" waCaption="s" waFontWeight="semibold" waText>Request-Response Flow</div>
					<div class="mermaid-diagram">
						<markdown [data]="mdContent_29" mermaid></markdown>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>